angular.module('impactx.validationbutton').controller('ValidationTooltipCtrl', [
    'ValidationTooltip',
    '$timeout',
    'mdPanelRef',
    'TranslationService',
    '$document',
    ValidationTooltipController
]);

function ValidationTooltipController(ValidationTooltip, $timeout, mdPanelRef, TranslationService, $document) {
    var self = this;
    ValidationTooltip.panelRef = mdPanelRef;

    self.hide = ValidationTooltip.hide;
    self.cancelPromise = ValidationTooltip.cancelPromise;

    self.trns = {
        completeRequiredFields: TranslationService.get("completeRequiredFields")
    }

    self.scrollToForAngular = function(id,item) {
        var compRef, errorProps;
        //console.warn('scrollToForAngular: ', id, item, self.errorData);
        if(typeof item === 'object' && typeof item.errorObj === 'object') {
            compRef = item.errorObj.componentRef;
            errorProps = item.errorObj.errorProperties;
            if(typeof compRef === 'object') {
                if(typeof compRef.focusOnError === 'function') {
                    // Eventually some properties
                    compRef.focusOnError({
                        errorProperties: errorProps,
                        sourceComponent: compRef
                    });
                } else {
                    try {
                        console.error('componentRef does not have focusOnError function.')
                    }catch(e){}
                }
            } else {
                try {
                    console.error('Angular error objekt does not have componentRef.')
                }catch(e){}
            }
        }
    };

    self.scrollTo = function (id) {
        var target = angular.element('ng-view').find('md-content');
        var element = angular.element(document.getElementById(id));
        if (!element.offset()) {
            element = $document.find("[name='" + id + "']");
        }
        // Opposite of element.closest("md-content, md-dialog-content");
        const content = element.parents("md-content, md-dialog-content").last();
        if(content.length > 0) {
            target = content;
        }

        var topOffset = element.offset().top + target.scrollTop();
        target.animate({
            scrollTop: topOffset - target.offset().top - 64
        }, 350);

        var previousBorder = element.css('border')
        element.css({'border': '2px solid red'});

        $timeout(function () {
            element.css({'border': previousBorder})
        }, 2000);


        ValidationTooltip.isActive = false;
        ValidationTooltip.hide();
    }

    self.getErrorTitleExt = function (titleKey) {
        // Für Angular required-Fehler
        if(titleKey === 'required') {
            return self.trns.completeRequiredFields;
        }
        var translation = TranslationService.get(titleKey);
        if (!translation) {
            return TranslationService.get("invalidFields");
        }

        return translation;
    };
}